
import React from "react";
import { formatDistanceToNow } from "date-fns";
import { nl } from "date-fns/locale";
import { Badge } from "@/components/ui/badge";
import UserAvatar from "./UserAvatar";
import { FeedbackCategoryTag } from "@/types/feedback";

interface MessageHeaderProps {
  username: string;
  timestamp: string;
  edited_at?: string | null;
  category_tag?: string | null;
}

const MessageHeader: React.FC<MessageHeaderProps> = ({
  username,
  timestamp,
  edited_at,
  category_tag,
}) => {
  const getCategoryColor = () => {
    switch (category_tag as FeedbackCategoryTag) {
      case "bug":
        return "bg-red-500 hover:bg-red-600";
      case "idee":
        return "bg-green-500 hover:bg-green-600";
      case "vraag":
        return "bg-blue-500 hover:bg-blue-600";
      case "algemeen":
      default:
        return "bg-gray-500 hover:bg-gray-600";
    }
  };

  return (
    <div className="pb-2 flex flex-row items-center gap-3">
      <UserAvatar username={username} />
      <div className="flex flex-col space-y-1">
        <div className="font-semibold">{username}</div>
        <div className="text-xs text-muted-foreground">
          {formatDistanceToNow(new Date(timestamp), {
            addSuffix: true,
            locale: nl,
          })}
          {edited_at && <span className="ml-2 italic">(bewerkt)</span>}
        </div>
      </div>
      {category_tag && (
        <Badge className={`ml-auto ${getCategoryColor()}`}>
          {category_tag}
        </Badge>
      )}
    </div>
  );
};

export default MessageHeader;
